import React from "react";
import { TraceAgentsView } from "./TraceAgentsView";
import { MessagesView } from "./MessagesView";

interface TraceInteractionViewProps {
  trace: Record<string, any> | null;
}

/**
 * Renders trace content in a human-readable format.
 * Supports:
 * - Multi-agent trace (agent_instance_by_id)
 * - Legacy agents array
 * - Simple messages array (reward format)
 */
export function TraceInteractionView({ trace }: TraceInteractionViewProps) {
  if (!trace) {
    return null;
  }

  // Resolve nested trace (some APIs wrap in { trace: {...} })
  const payload = trace?.trace ?? trace;

  // Multi-agent or legacy agents schema
  const hasAgentInstances =
    payload?.agent_instance_by_id ||
    (Array.isArray(payload?.agents) && payload.agents.length > 0);

  // Single AgentInstance (reward API format: { id, name, interactions })
  const isSingleInstance =
    payload?.id != null &&
    payload?.name != null &&
    Array.isArray(payload?.interactions) &&
    payload.interactions.length > 0;

  if (hasAgentInstances || isSingleInstance) {
    return (
      <TraceAgentsView
        traceData={hasAgentInstances ? { trace: payload } : payload}
        instanceScores={{}}
      />
    );
  }

  // Simple messages array (reward format)
  const messages = payload?.messages ?? trace?.messages;
  if (Array.isArray(messages) && messages.length > 0) {
    const tools = payload?.tools ?? trace?.tools;
    return (
      <MessagesView
        messages={messages}
        tools={Array.isArray(tools) ? tools : undefined}
      />
    );
  }

  return null;
}
